<!-- DataQueryMessage.vue -->
<script lang="ts" setup> 
    //import * as MessageLib from "messagelib" 
    import { onMounted } from 'vue';
     
    // Outgoing message methods
    defineExpose({openDataQuery,closeDataQuery});

    // Events from incoming messages
	const emit = defineEmits<{
		(e: "openDataQuery", payload: MessageLib.DataQuery.DataQueryPayload) : void,
		(e: "closeDataQuery", payload: MessageLib.DataQuery.CloseDataQueryPayload) : void
	}>();
    const props = withDefaults(defineProps<{ 
        componentID: string,
        dataQueryParent: boolean
    }>(),
    { 
    });

    onMounted(()=>{
        if (props.dataQueryParent) {
           MessageLib.DataQuery.sink.closeDataQueryView(closeDataQuerySink);
        }
        else {
            MessageLib.DataQuery.sink.openDataQueryView(openDataQuerySink);
        }
    });
    // Validate incoming messages, the data query window can be opened multiple times, we want the message to go to/come from just one of them...
    function validateDataQueryMessage(payload : any) : boolean {
        if ("dataQueryComponentId" in payload) {
            if (props.componentID === payload.dataQueryComponentId)  {
                return true;
            }
        }
        return false;
    }
    // Raise message events
	function openDataQuerySink(payload: unknown) : void 	{ 
        if (!validateDataQueryMessage(payload)) {
            return;
        }
        emit("openDataQuery", <MessageLib.DataQuery.DataQueryPayload>payload);
	}
	function closeDataQuerySink(payload: unknown) : void {
        if (!validateDataQueryMessage(payload)) {
            return;
        }
        emit("closeDataQuery", <MessageLib.DataQuery.CloseDataQueryPayload>payload); 
	}

    // Send Messages
    function openDataQuery(payload: MessageLib.DataQuery.DataQueryPayload) :void {
        MessageLib.DataQuery.openDataQueryView(payload);  
    }
    function closeDataQuery(payload: MessageLib.DataQuery.CloseDataQueryPayload) :void {
        MessageLib.DataQuery.closeDataQueryView(payload);  
    } 
</script>
